<div class="container" [@animation]="state" (@animation.done)="onAnimationDone($event)" [ngClass]="color">
    <div class="content" libSnackbar></div>
</div>
